import { PromiseExtended } from 'dexie';
import { HustroDb, HustroDbTablesUnion } from '.';
import { rethrowServiceTableFailure } from 'serviceWorker/helpers/dataLog';
import { wrapQuery } from './queryWrapper';

export function entityDbClearFactory(
  db: HustroDb,
  dbEntityTables: HustroDbTablesUnion[],
  dbEntityClear: () => Promise<void>,
  dbServiceClear: () => Promise<void>,
  broadcastClear: () => void
): () => Promise<void> {
  return wrapQuery(db, (): PromiseExtended<void> => {
    const tables = dbEntityTables.map((table) => db[table]);

    return db
      .transaction(
        'rw',
        tables,
        function clearTransaction(): Promise<any> {
          return Promise.all([dbEntityClear(), dbServiceClear()]);
        }
      )
      .then(() => {
        broadcastClear();
      })
      .catch(rethrowServiceTableFailure('clear', dbEntityTables));
  });
}
